import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './polyfills';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');
const app = (
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>
);

if (container && container.hasChildNodes()) {
    hydrateRoot(container, app);
} else if (container) {
    const root = createRoot(container);
    root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
